// extracted by css-extract-rspack-plugin
export default {"root":"root-TS3N4w","branch":"branch-ur5qKN","branchLabel":"branchLabel-VFZPQp text-xs-medium","branchBody":"branchBody-xTli4T"};